import { ReactNode } from "react";

type ShowProps = {
  fallback?: ReactNode;
  when?: boolean;
  children: ReactNode;
};

export function Show({ fallback, when = false, children }: ShowProps) {
  return (
    <>
      {when && children}

      {!when && fallback}
    </>
  );
}
